<template>
  <div>
    <!-- Alert -->
    <alert-message :dialog="snackbar"></alert-message>
    <template v-if="layout == authLayout">
      <auth-layout></auth-layout>
    </template>
    <template v-else-if="layout == adminLayout">
      <admin-layout></admin-layout>
    </template>
    <template v-else>
      <app-layout></app-layout>
    </template>
    <!-- Progress Bar -->
    <v-dialog v-model="loader" width="70">
      <v-progress-circular
        :size="70"
        color="info"
        class="overflow-hidden"
        indeterminate
      ></v-progress-circular>
    </v-dialog>
    <ReminderMessageDialog
      v-if="reminderMessageDialog.show"
      :show="reminderMessageDialog.show"
      :error="reminderMessageDialog.error"
    ></ReminderMessageDialog>
  </div>
</template>

<script>
import AuthLayout from "@/layouts/AuthLayout";
import AppLayout from "@/layouts/AppLayout";
import AdminLayout from "@/layouts/AdminLayout";
import ReminderMessageDialog from "@/components/ReminderMessageDialog";
import { EventBus } from "@/event-bus";
import { mapGetters, mapState } from "vuex";
import DEFINES from "@/defines";
import i18n from "@/i18n";
import AlertMessage from "@/components/dialogBox/AlertMessage";

export default {
  name: "app",
  components: {
    AuthLayout,
    AppLayout,
    AdminLayout,
    ReminderMessageDialog,
    AlertMessage
  },
  data() {
    return {
      loader: false,
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      reminderMessageDialog: {
        show: false,
        error: null
      },
      appLayout: DEFINES.LAYOUT_APP,
      authLayout: DEFINES.LAYOUT_AUTH,
      adminLayout: DEFINES.LAYOUT_ADMIN
    };
  },

  computed: {
    ...mapGetters("app", {
      layout: "appLayout",
      is_rtl: "is_rtl"
    }),
    ...mapState({
      logged_in_user: state => state.user.profile,
      app_i8n_locale: state => state.app.i18n_locale
    })
  },

  mounted() {
    // why this function ? = Whenever we change user role from database then after reload we will get fresh data.
    this.getUpdatedUser();
    // Whenever the app will mount it will take default i18n.locale
    // but we need to take persist locale of user
    i18n.locale = this.app_i8n_locale;
  },

  created() {
    EventBus.$on("showMessage", payload => {
      this.snackbar = {
        show: true,
        color: payload.color,
        text: payload.message
      };
    });
    EventBus.$on("showReminderMessageDialog", payload => {
      this.reminderMessageDialog = {
        show: true,
        error: payload.error
      };
    });
    EventBus.$on("hideReminderMessageDialog", payload => {
      this.reminderMessageDialog = {
        show: false
      };
    });

    EventBus.$on("showLoader", payload => {
      this.loader = true;
    });
    EventBus.$on("hideLoader", payload => {
      this.loader = false;
    });

    // this.$vuetify.theme.dark = true;
  },

  methods: {
    getUpdatedUser() {
      try {
        if (this.logged_in_user) {
          this.$store.dispatch("user/get", {
            id: this.logged_in_user.id
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
<style scoped>
.v-dialog {
  box-shadow: none !important;
}
.v-snack--bottom {
  position: inherit;
  display: inline;
}
</style>
